import React from "react";
import Layout from "../components/Layout";
import ProductCarousel from "../components/ProductCarousel";
import Slider from "../components/Slider/Slider";
import NewsCarousel from "../components/NewsCarousel";
import PromoBanner from "./PromoBanner";

export default function Home() {
  return (
    <Layout>
      <Slider />
      <ProductCarousel />
      <NewsCarousel />
      <PromoBanner imageUrl="/images/download.jpg" to="/haqqimizda" />
    </Layout>
  );
}
